export const MAP_SHEET_HEIGHT_RATIO = 0.6;
export const MAP_SHEET_HEIGHT_CLASS = 'max-h-[60dvh]';
